import Typography from "@mui/material/Typography";
import TableDisplay from "../../TableDisplay/TableDisplay";
import { achievedColumns, brandColumn, reportModes, staticBrandWiseData, subTableComponentStyle, unitColIdentifier } from "../../data";
import BlackBorderTable from "../TableLayouts/BlackBorderTable/BlackBorderTable";
import grey from "@mui/material/colors/grey";
import { gpWithChMarginTableColumns, reportModeTableColumnsMap } from "./data";

const GpTable = ({ mode, tableRows = [], setTableRows, rowSpanColumns, customGroupBorderBottom }) => {
	return (
		<BlackBorderTable sx={{ display: "flex", flexWrap: "wrap", flexGrow: 1, flexDirection: "column" }}>
			<Typography textAlign="center" sx={{ background: grey[800], color: "white" }} height="24px" width="100%">
				{mode ? reportModes[mode]?.table_name : reportModes.OPS.table_name}
			</Typography>
			<TableDisplay
				disableTableBorder
				columns={Object.values(reportModeTableColumnsMap[mode] ?? gpWithChMarginTableColumns)}
				rows={[
					Object.values(reportModeTableColumnsMap[mode] ?? gpWithChMarginTableColumns)?.reduce(
						(acc, row) => {
							acc[row.key] = row?.unit ?? "";
							return acc;
						},
						{ [unitColIdentifier]: "units" }
					),
					...tableRows,
				]}
				rowHeight="30px"
				rowSpanColumns={rowSpanColumns}
				customGroupBorderBottom={customGroupBorderBottom}
				// columnWidth="85px"
			/>
		</BlackBorderTable>
	);
};

export default GpTable;
